var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import throttle from 'lodash/throttle';
import { init as initConfig } from './config/index';
import Api from './model/api';
import AccsModule from './module/accs';
import EmojiModule from './module/emoji';
import I18n, * as i18nKey from './module/i18n';
import MsgImage from './module/msg-image';
import ServerTime from './module/server-time';
import SessionDbModule from './module/session-db';
import SessionListModule from './module/session-list';
import SyncModule from './module/sync';
import UserModule from './module/user';
import Emitter from './utils/emitter';
import errorFormat from './utils/error-format';
import createGuid from './utils/guid';
import LogMsgTool, { accsMsgToLog, SyncAccsLogKey } from './utils/log-msg';
export { getMtopAccsConfig } from './config/index';
var NO_CONVERSATION_SESSION = 'NO_CONVERSATION_SESSION';
var ImSDK = (function (_super) {
    __extends(ImSDK, _super);
    function ImSDK(param) {
        var _this = _super.call(this) || this;
        var config = _this.config = initConfig(param);
        _this._api = Api.getInstance(config);
        _this._emoji = EmojiModule.getInstance(config);
        _this._i18n = I18n.getInstance(config);
        _this._user = UserModule.getInstance(config);
        _this._stime = new ServerTime(config);
        _this.syncData = throttle(function (syncId) {
            _this._sync.syncDataList(syncId, 0);
        }, config.syncThrottle || 1000);
        if (config.userId) {
            return Promise.all([
                _this._user.getLoginInfo(),
                _this.init(),
            ]).then(function (_a) {
                var _b = __read(_a, 2), userRes = _b[0], initRes = _b[1];
                _this._loginUser = userRes;
                return Promise.resolve(initRes);
            });
        }
        else {
            return _this._user.getLoginInfo().then(function (data) {
                config.userId = data.userId;
                _this._loginUser = data;
                return _this.init().catch(function (err) { return Promise.reject(errorFormat(err)); });
            });
        }
    }
    Object.defineProperty(ImSDK.prototype, "REJECTION_NO_CONVERSATION_SESSION", {
        get: function () {
            return Promise.reject({
                type: NO_CONVERSATION_SESSION,
                message: this._i18n.getTxt(i18nKey.NO_CONVERSATION_SESSION),
            });
        },
        enumerable: false,
        configurable: true
    });
    ImSDK.prototype.close = function () {
        if (this._accs) {
            this._sess = null;
            this._sessDb = null;
            return this._accs.close();
        }
        else {
            return Promise.resolve();
        }
    };
    ImSDK.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var config, allPromise;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = this.config;
                        allPromise = [];
                        this._accs = AccsModule.getInstance(config);
                        this.bindAccsEvent();
                        this._accs.init();
                        this.isSessionTimeout = false;
                        this._msgImg = MsgImage.getInstance(config);
                        this._sess = SessionListModule.getInstance(config);
                        this._sessDb = SessionDbModule.getInstance(config);
                        this.bindSessionEvent(config);
                        allPromise.push(this._initSession());
                        this._sync = SyncModule.getInstance(config);
                        this._api.on('sessionTimeout', function () {
                            _this.isSessionTimeout = true;
                            _this._accs.isSessionTimeout = true;
                            _this._accs.close();
                            _this.emit('error', { type: 'SESSION_TIMEOUT', message: 'SESSION_TIMEOUT' });
                        });
                        return [4, Promise.all(allPromise)];
                    case 1:
                        _a.sent();
                        setTimeout(function () {
                            if (!_this._sessDb) {
                                return;
                            }
                            _this._sessDb.emit('session_update');
                            console.log('全部初始化完成');
                        }, 10);
                        return [2, this];
                }
            });
        });
    };
    ImSDK.prototype.refreshSessionData = function () {
        if (this._sessDb) {
            this._sessDb.emit('session_update');
        }
    };
    ImSDK.prototype.bindSessionEvent = function (config) {
        var _this = this;
        if (this._sessDb) {
            this._sessDb.on('session_update', function () {
                if (!_this._sessDb) {
                    return;
                }
                var finalSession = _this._sessDb.getAll();
                var shouldFilterShunted = config.shouldFilterShunted;
                if (shouldFilterShunted) {
                    finalSession = finalSession.filter(function (item) { return item.isShuntedToOthers !== 'true'; });
                }
                _this.emit('sessionListUpdate', finalSession);
            });
        }
    };
    ImSDK.prototype.bindAccsEvent = function () {
        var _this = this;
        this._accs.off('connection');
        this._accs.on('connection', function (retryCount) {
            console.log('accs 连接成功', retryCount);
            _this.emit('accsConnection', retryCount);
        });
        this._accs.off('sync');
        this._accs.on('sync', function (syncId, syncBody) {
            _this.syncData(syncId);
            if (syncBody.messageId !== undefined) {
                LogMsgTool.saveSyncMsgCache(accsMsgToLog(syncBody), SyncAccsLogKey);
            }
        });
        this._accs.off('error');
        this._accs.on('error', function (err) {
            _this.emit('error', { type: 'ACCS_ERROR', message: err.message, flag: err === null || err === void 0 ? void 0 : err.flag });
        });
        this._accs.off('close');
        this._accs.on('close', function (code) {
            _this.emit('error', { type: 'ACCS_CLOSED', message: _this._i18n.getTxt(i18nKey.ACCS_CLOSED), error: code });
        });
        this._accs.off('reconnecting');
        this._accs.on('reconnecting', function () {
            _this.emit('reconnecting');
        });
        this._accs.off('reconnected');
        this._accs.on('reconnected', function () {
            _this.emit('reconnected');
            if (_this._sessDb) {
                _this._sync.syncDataList(_this._sessDb.syncId, 1);
            }
        });
    };
    ImSDK.prototype._initSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._sess) return [3, 5];
                        return [4, this._sess.init()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4, this._sync.init()];
                    case 3:
                        _a.sent();
                        return [3, 5];
                    case 4:
                        err_1 = _a.sent();
                        if (err_1 === 'SYNC_FORCE_INIT') {
                            if (this._sessDb) {
                                this._sessDb.clean();
                            }
                            return [2, this._initSession()];
                        }
                        else {
                            return [2, Promise.reject(err_1)];
                        }
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    };
    ImSDK.prototype.getEmojiList = function () {
        return this._emoji.get();
    };
    ImSDK.prototype.getSettingList = function () {
        if (!this._sess || !this._sess.conversationSession) {
            return this.REJECTION_NO_CONVERSATION_SESSION;
        }
        var conversationSession = this._sess.conversationSession;
        return conversationSession.getSettingList();
    };
    ImSDK.prototype.uploadImg = function (files, cb) {
        if (typeof this.config._url.uploadImg === 'function') {
            return this.config._url.uploadImg(files, cb);
        }
        else {
            return this._msgImg.uploadImg(files, cb);
        }
    };
    ImSDK.prototype.createSession = function (accountId, accountType, fromCode, extra) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this._sess) {
                    return [2, this._sess.openSession(accountId, accountType, fromCode, extra)];
                }
                else {
                    return [2, this.REJECTION_NO_CONVERSATION_SESSION];
                }
                return [2];
            });
        });
    };
    ImSDK.prototype.deleteSession = function (sessionId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this._sess) {
                    return [2, this._sess.deleteSession(sessionId)];
                }
                else {
                    return [2, this.REJECTION_NO_CONVERSATION_SESSION];
                }
                return [2];
            });
        });
    };
    ImSDK.prototype.getSessionList = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this._sess) {
                    return [2, Promise.resolve(this._sess.getSessionList())];
                }
                else {
                    return [2, this.REJECTION_NO_CONVERSATION_SESSION];
                }
                return [2];
            });
        });
    };
    ImSDK.prototype.fetchMoreSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this._sess) {
                    return [2, this._sess.fetchMoreSession()];
                }
                else {
                    return [2, this.REJECTION_NO_CONVERSATION_SESSION];
                }
                return [2];
            });
        });
    };
    ImSDK.prototype.getUsersInfo = function (users) {
        return __awaiter(this, void 0, void 0, function () {
            var _user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!Array.isArray(users)) {
                            users = [users];
                        }
                        _user = this._user;
                        return [4, _user.getUsers(users)];
                    case 1:
                        _a.sent();
                        return [2, users.map(function (user) {
                                return _user.getUserData(user.userType, user.userId);
                            })];
                }
            });
        });
    };
    ImSDK.prototype.sendMessage = function (templateType, templateData, msgId, ext) {
        if (ext === void 0) { ext = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _i18n, conversationSession;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _i18n = this._i18n;
                        if (!this._sess || !this._sess.conversationSession) {
                            return [2, this.REJECTION_NO_CONVERSATION_SESSION];
                        }
                        conversationSession = this._sess.conversationSession;
                        if (!this.config.messageTemplateInfo[templateType]) {
                            return [2, Promise.reject({ type: 'NO_SUPPORT_MESSAGE_TYPE', message: _i18n.getTxt(i18nKey.NO_SUPPORT_MESSAGE_TYPE) })];
                        }
                        if (!templateData) {
                            return [2, Promise.reject({ type: 'NOTHING_TO_SEND', message: _i18n.getTxt(i18nKey.NOTHING_TO_SEND) })];
                        }
                        return [4, conversationSession.sendMessage(templateType, templateData, msgId, ext)];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    ImSDK.prototype.createGuid = function () {
        return createGuid();
    };
    ImSDK.prototype.getMessageList = function () {
        if (!this._sess || !this._sess.conversationSession) {
            return this.REJECTION_NO_CONVERSATION_SESSION;
        }
        var conversationSession = this._sess.conversationSession;
        return Promise.resolve(conversationSession.getMessageList());
    };
    ImSDK.prototype.getMoreMessage = function (isDownward) {
        if (!this._sess || !this._sess.conversationSession) {
            return this.REJECTION_NO_CONVERSATION_SESSION;
        }
        var conversationSession = this._sess.conversationSession;
        return conversationSession.getMoreMessage(isDownward);
    };
    ImSDK.prototype.setConversationSession = function (sessionId, nonReadNumber, startTime, clearCache) {
        return __awaiter(this, void 0, void 0, function () {
            var oldConver, sessionView_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._sess) return [3, 2];
                        oldConver = this._sess.conversationSession;
                        return [4, this._sess.setConversationSession(sessionId, nonReadNumber, startTime, clearCache)];
                    case 1:
                        sessionView_1 = _a.sent();
                        if (oldConver) {
                            oldConver.off('message_update').off('read_new_message');
                        }
                        sessionView_1 && sessionView_1.on('message_update', function () {
                            _this.emit('messageListUpdate', sessionView_1.getMessageList());
                        }).on('read_new_message', function (msg) {
                            _this.emit('readNewMessage', msg);
                        }).on("message_withdraw", function (messageId) {
                            _this.emit("messageWithdraw", messageId);
                        });
                        return [2, sessionView_1];
                    case 2: return [2, this.REJECTION_NO_CONVERSATION_SESSION];
                }
            });
        });
    };
    ImSDK.prototype.messageWithdraw = function (messageId) {
        if (!this._sess || !this._sess.conversationSession) {
            return this.REJECTION_NO_CONVERSATION_SESSION;
        }
        var conversationSession = this._sess.conversationSession;
        return conversationSession.messageWithdraw(messageId);
    };
    return ImSDK;
}(Emitter));
export { ImSDK };
export default function loader(opt) {
    return new ImSDK(opt);
}
if (!window.lib) {
    window.lib = {};
}
window.lib.imSDK = loader;
